import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaDesktop, FaShoppingCart, FaCreditCard, FaEye, FaVolumeMute, FaPlayCircle, 
  FaClock, FaChartLine, FaShieldAlt, FaDownload, FaCheckCircle, 
  FaStar, FaArrowRight, FaCog, FaStore, FaTv, FaBroadcastTower,
  FaTimes, FaChevronLeft, FaChevronRight
} from 'react-icons/fa';
import './PokladnicnyDisplejPage.css';

const PokladnicnyDisplejPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Modal state management
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const galleryImages = [
    '/display/display1.png',
    '/display/display2.png'
  ];

  const openModal = (imageSrc) => {
    const index = galleryImages.indexOf(imageSrc);
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const features = [
    {
      icon: FaDesktop,
      title: 'Moderný digitálny displej',
      description: 'Displej s vysokým rozlíšením nahradzujúci tradičné dvojriadkové zobrazovače s moderným dizajnom'
    },
    {
      icon: FaShoppingCart,
      title: 'Detailné zobrazenie nákupu',
      description: 'Zobrazenie všetkých položiek, cien, zliav a celkovej sumy v prehľadnej forme'
    },
    {
      icon: FaCreditCard,
      title: 'Informácie o platbe',
      description: 'Real-time zobrazenie stavu platby, typu karty a pokynov pre zákazníka'
    },
    {
      icon: FaPlayCircle,
      title: 'Reklamné spoty',
      description: 'Počas neaktivity automaticky prehráva reklamné videá a propagačné materiály'
    },
    {
      icon: FaEye,
      title: 'Atraktívny vizuál',
      description: 'Moderný grafický dizajn s animáciami a prehľadným zobrazením informácií'
    },
    {
      icon: FaBroadcastTower,
      title: 'Centrálne riadenie',
      description: 'Vzdialená správa obsahu a reklamných spotov zo centrálneho systému'
    }
  ];

  const benefits = [
    {
      icon: FaEye,
      title: 'Zákaznícka skúsenosť',
      value: '85%',
      description: 'Zlepšenie spokojnosti zákazníkov s moderným zobrazením'
    },
    {
      icon: FaChartLine,
      title: 'Zvýšenie predaja',
      value: '25%',
      description: 'Rast tržieb vďaka reklamným spotom'
    },
    {
      icon: FaStore,
      title: 'Modernosť predajne',
      value: '95%',
      description: 'Zvýšenie imidžu a modernosti predajného miesta'
    }
  ];

  const packages = [
    {
      name: 'BASIC DISPLEJ',
      price: '399€',
      description: 'Pre menšie predajne a kaviarně',
      features: [
        'HD digitálny displej 15"',
        'Zobrazenie nákupu',
        'Základné animácie',
        'Reklamné slajdy',
        '1 displej',
        'Email podpora'
      ]
    },
    {
      name: 'STANDARD DISPLEJ',
      price: '699€',
      description: 'Pre reštaurácie a obchody',
      features: [
        'Všetky funkcie BASIC',
        'Full HD displej 21"',
        'Video reklamné spoty',
        'Centrálne riadenie obsahu',
        'Do 5 displejov',
        'SignalR synchronizácia',
        'Prioritná podpora'
      ],
      popular: true
    },
    {
      name: 'PREMIUM DISPLEJ',
      price: '1199€',
      description: 'Pre reťazce a veľké predajne',
      features: [
        'Všetky funkcie STANDARD',
        '4K Ultra HD displej 27"',
        'Interaktívne prvky',
        'Advanced analytics',
        'Neobmedzený počet displejov',
        'Custom reklamy a branding',
        'Podpora 24/7 a údržba'
      ]
    }
  ];

  const industries = [
    {
      icon: FaStore,
      title: 'Maloobchod',
      description: 'Supermarkety, obchody s oblečením, elektronikou'
    },
    {
      icon: FaShoppingCart,
      title: 'Reštaurácie',
      description: 'Rýchle občerstvenie, kaviarne, reštaurácie'
    },
    {
      icon: FaCreditCard,
      title: 'Benzínové stanice',
      description: 'Čerpacie stanice s obchodmi a službami'
    },
    {
      icon: FaTv,
      title: 'Reťazce',
      description: 'Veľké obchodné reťazce a franšízy'
    }
  ];

  const testimonials = [
    {
      name: 'Ing. Tomáš Krejčí',
      company: 'FRESH MARKET s.r.o.',
      text: 'Zákaznícky displej úplne zmenil vzhľad našej predajne. Zákazníci sú nadšení z moderného dizajnu.',
      rating: 5
    },
    {
      name: 'Anna Svobodová',
      company: 'CAFÉ CENTRAL',
      text: 'Reklamné spoty počas neaktivity nám zvýšili predaj doplnkových produktov o 30%.',
      rating: 5
    }
  ];

  const technologies = [
    {
      name: 'React',
      description: 'Frontend používateľského rozhrania',
      color: '#61dafb'
    },
    {
      name: 'C#',
      description: 'Backend aplikačná logika',
      color: '#239120'
    },
    {
      name: 'MSSQL',
      description: 'Databázový systém',
      color: '#cc2927'
    },
    {
      name: 'SignalR',
      description: 'Komunikácia v reálnom čase',
      color: '#512bd4'
    }
  ];

  return (
    <div className="displej-page">
      {/* Hero Section */}
      <section className="displej-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Zákaznícky displej</h1>
              <h2>Moderný digitálny displej</h2>
              <p>
                Moderný digitálny displej pre pokladne, ktorý nahrádza tradičné dvojriadkové 
                zobrazovače. Zobrazuje viac informácií, ponúka lepší dizajn a počas neaktivity 
                prehráva reklamné spoty.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                 <FaArrowRight /> Žiadosť o ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img src="/pokladnicny_displej.png" alt="Zákaznícky displej" className="hero-product-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2>Ukážky displeja</h2>
          <div className="gallery-grid">
            <div className="gallery-item" onClick={() => openModal('/display/display1.png')}>
              <img src="/display/display1.png" alt="Zákaznícky displej - ukážka 1" />
            </div>
            <div className="gallery-item" onClick={() => openModal('/display/display2.png')}>
              <img src="/display/display2.png" alt="Zákaznícky displej - ukážka 2" />
            </div>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="technologies-section">
        <div className="container">
          <h2>Použité technológie</h2>
          <div className="technologies-grid">
            {technologies.map((tech, index) => (
              <div key={index} className="technology-card">
                <div className="tech-name" style={{ color: tech.color }}>
                  {tech.name}
                </div>
                <p>{tech.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Pokročilé funkcie systému</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Výsledky, ktoré môžete očakávať</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <div className="container">
          <h2>Vhodné pre všetky typy predajní</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <industry.icon />
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Section */}
      <section className="customers-section">
        <div className="container">
          <h2>Naši klienti</h2>
          <div className="customers-grid">
            <a 
              href="https://www.kasa.sk/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="customer-card"
            >
              <img src="/kasa.jpg" alt="Kasa" />
              <h3>KASA ZÁLOŽNÁ a.s.</h3>
              <p>KASA ZÁLOŽNÁ a.s. je jednou z najväčších spoločností na Slovensku, poskytujúcich peňažnú hotovosť formou záložného práva.</p>
            </a>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {isModalOpen && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>
            <button className="modal-prev" onClick={prevImage}>
              <FaChevronLeft />
            </button>
            <img 
              src={galleryImages[currentImageIndex]} 
              alt={`Zákaznícky displej - ukážka ${currentImageIndex + 1}`}
            />
            <button className="modal-next" onClick={nextImage}>
              <FaChevronRight />
            </button>
            <div className="modal-counter">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PokladnicnyDisplejPage;